import * as React from 'react';
import { useSelector } from 'react-redux';
import { Contacts as ContactsComponent } from '../../components/Contacts';
import { SPThemeWrapper } from '../../components/SPThemeWrapper';
import { checkFsk, getContacts, getFullAddress } from '../../selectors';
import { trackShowPhone } from '../../services';
import { getWorkTime, phoneToString } from '../../utils';
import { Call } from '../Call';
import { CallbackButtonContainer } from '../CallbackButton';

export function Contacts() {
  const { workTime, website, phone } = useSelector(getContacts);
  const fullAddress = useSelector(getFullAddress);
  const isFsk = useSelector(checkFsk);
  const preparedWorkTime = React.useMemo(() => getWorkTime(workTime), [workTime]);
  const preparedPhone = React.useMemo(() => phoneToString(phone), [phone]);

  return (
    <ContactsComponent
      address={fullAddress}
      workTime={preparedWorkTime}
      website={website || null}
      phoneNumber={preparedPhone}
      call={
        <SPThemeWrapper theme={isFsk ? 'fsk_fill_primary' : undefined}>
          <Call
            onShowPhone={trackShowPhone('CallBack_popup_open_headblock')}
            showPhoneStyles={{ fullWidth: true }}
            openContactsStyles={{ fullWidth: true }}
          />
        </SPThemeWrapper>
      }
      callback={
        <CallbackButtonContainer
          customTheme={isFsk ? 'fsk_fill_secondary' : undefined}
          fullWidth={true}
          place="headblock"
          theme="fill_secondary"
        />
      }
    />
  );
}
